import React from 'react';
import TrustlyLogo from './icons/logo-trustly.png';
import VipPreferredLogo from './icons/logo-vip-preferred.png';
import PaypalLogo from './icons/logo-paypal.png';
import SightlineLogo from './icons/logo-play+.png';
import CreditCardLogo from './icons/logo-credit-card.png';
import SkrillLogo from './icons/logo-skrill.png';
// import CashLogo from './icons/logo-cash.png';

export const PaymentMethodIds = {
	Trustly: 1,
	VipPreferred: 6,
	Paypal: 7,
	CreditCard: 8,
	Cash: 9,
	Skrill: 10,
	Sightline: 11,
};

export enum PaymentPages {
	Home,
	Select,
	DepositSuccessful,
	DepositError,
}

export const PaymentMethods = {
	Trustly: { id: 1, name: 'ONLINE BANKING WITH TRUSTLY', icon: <img src={TrustlyLogo} alt="Trustly" /> },
	VipPreferred: { id: 6, name: 'ACH-CHECK', icon: <img src={VipPreferredLogo} alt="ACH" /> },
	Paypal: { id: 7, name: 'PAYPAL', icon: <img src={PaypalLogo} alt="Paypal" /> },
	Sightline: { id: 11, name: 'Sightline', icon: <img src={SightlineLogo} alt="Play+" /> },
	CreditCard: { id: 8, name: 'CREDIT / DEBIT', icon: <img src={CreditCardLogo} alt="Credit Card" /> },
	Skrill: { id: 10, name: 'SKRILL', icon: <img src={SkrillLogo} alt="Skrill" /> },
	// Cash: { id: 9, name: 'PAYSAFE:CASH', icon: <img src={CashLogo} alt="Cash" /> }, // US only
};

export const ConvertPaymentTypeToView = (paymentMethod: { id: number; name: string }) => {
	if (paymentMethod.id === PaymentMethodIds.Trustly) return PaymentMethods.Trustly;
	if (paymentMethod.id === PaymentMethodIds.VipPreferred) return PaymentMethods.VipPreferred;
	if (paymentMethod.id === PaymentMethodIds.Paypal) return PaymentMethods.Paypal;
	if (paymentMethod.id === PaymentMethodIds.Sightline) return PaymentMethods.Sightline;
	if (paymentMethod.id === PaymentMethodIds.CreditCard) return PaymentMethods.CreditCard;
	if (paymentMethod.id === PaymentMethodIds.Skrill) return PaymentMethods.Skrill;
	// if (paymentMethod.id === PaymentMethodIds.Cash) return PaymentMethods.Cash;
	return PaymentMethods.CreditCard;
};

export interface DepositPage {
	pageIndex: number;
	subtitle?: string;
	previousPageIndex?: number;
	body: any; // this is a function that returns a node, but not a functional component
}
